module.exports = __webpack_public_path__ + "static/media/gndec.8bb2455d.png";